import { render, staticRenderFns } from "./SMSSettings.vue?vue&type=template&id=1668bef8&"
import script from "./SMSSettings.vue?vue&type=script&lang=js&"
export * from "./SMSSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports